import React from 'react';
import {
  ItemContainer,
  ItemContainerText,
  ItemContainerHeader,
  ItemContainerFooter,
} from '../../Item';
import { Row, Col, InputGroup, Input } from 'reactstrap';
import Indicator, { IndicatorStateOptions } from '../../Indicator';
import InformationButton from '../../Item/InformationButton';
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import ErrorField from '../../../containers/Fields/ErrorField';
const formatStr = 'dd/MM/yyyy';
export type DateInputRenderProps = {
  supportingLink?: React.MouseEventHandler;
  informationText?: string[];
  indicatorState?: IndicatorStateOptions;
  text?: string;
  enabled?: boolean;
  error?: string;
  disabled?: boolean;
  name: string;
  check?: boolean;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onChange?: (date: string) => void;
  value?: any;
};

const DateInput = (props: DateInputRenderProps) => {
  const {
    value,
    text,
    enabled,
    error,
    supportingLink,
    informationText,
    indicatorState: state,
  } = props;
  const dateObj = value ? moment(value).toDate() : null;
  return enabled === undefined || enabled ? (
    <ItemContainer pulsing={enabled !== undefined}>
      <ItemContainerText text={text}>
        {supportingLink ? <InformationButton onClick={supportingLink} /> : null}
      </ItemContainerText>
      <ItemContainerHeader>
        <div className="d-flex flex-row-reverse justify-content-between">
          {informationText
            ? informationText.map((info, index) => (
                <div key={index} className={'d-inline-flex'}>
                  <em className={'i-information-text'}>{info}</em>
                </div>
              ))
            : null}
        </div>
      </ItemContainerHeader>
      <Row noGutters={true} className="ic-item m-2">
        <Col>
          <InputGroup>
            <ReactDatePicker
              dateFormat={formatStr}
              onChange={date =>
                props.onChange &&
                date &&
                props.onChange(moment(date).toISOString())
              }
              onBlur={props.onBlur}
              onFocus={props.onBlur}
              showYearDropdown
              showMonthDropdown
              adjustDateOnChange
              maxDate={moment().toDate()} // note: stops selecting future dates
              minDate={moment().subtract(5, 'years').toDate()}
              strictParsing
              dropdownMode="select"
              placeholderText="Click to select a date"
              selected={dateObj}
              autoComplete="off"
              customInput={<Input invalid={!!error} />}
            />
          </InputGroup>
        </Col>
      </Row>
      <ItemContainerFooter>
        <div className="d-flex flex-row-reverse align-items-center ">
          <Indicator state={state} />
          <ErrorField name={props.name} />
        </div>
      </ItemContainerFooter>
    </ItemContainer>
  ) : null;
};
export default DateInput;
